/**
 * Kept apart from the component so `useSessionStorage` can read the defaults
 * without pulling the React tree for the floating panel into every consumer.
 */
export const DEFAULT_LINEAGE_FLOATING_WIDTH = 420;
export const DEFAULT_LINEAGE_FLOATING_HEIGHT = 340;
export const MIN_LINEAGE_FLOATING_WIDTH = 300;
export const MIN_LINEAGE_FLOATING_HEIGHT = 200;
/** Gap between the floating window and the edges of the content area. */
export const LINEAGE_FLOATING_MARGIN_PX = 12;

/** The corner of the content area the floating window rests in. */
export type TaoLineageFloatingCorner =
  `${"bottom" | "top"}-${"left" | "right"}`;
export const DEFAULT_LINEAGE_FLOATING_CORNER: TaoLineageFloatingCorner =
  "bottom-right";
